// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__k1_0H","checkboxCol":"Table_checkboxCol__6NC_I","emailCol":"Table_emailCol__3qfjk","actionCol":"Table_actionCol__2mKP9"};